'use strict';

const headerNavItemTokens = (theme) => ({
    headerNavItemPaddingX: theme.space.component.x.m,
    headerNavItemOverlayRadius: theme.radiuses.l,
    headerNavItemOverlayPaddingY: theme.space.component.y.s,
    headerNavItemAnchorTextColor: theme.colors.body.text,
    headerNavItemAnchorActiveTextColor: theme.colors.primary.normal,
    headerNavItemDropdownIconPaddingX: theme.space.component.x.xs,
    headerNavItemDropdownIconFontSize: theme.typography.fontSize.xs,
});

exports.headerNavItemTokens = headerNavItemTokens;
//# sourceMappingURL=headerNavItem.js.map
